<template>
  <div id="login" class="mainBody">
    <div class="page_head">
      <img
        style="height: 65px; width: 65px"
        src="../../../assets/img/logo.png"
      />
      百钢网
    </div>
    <div class="page_body">
      <div class="main_block">
        <div class="bg_block"></div>
        <div class="content_block">
          <ul class="tab_block">
            <li
              :class="postData.type == 2 ? 'selected' : ''"
              @click="changeTab(2)"
            >
              密码登录
            </li>
            <li
              :class="postData.type == 1 ? 'selected' : ''"
              @click="changeTab(1)"
            >
              短信登录
            </li>
          </ul>
          <section v-if="postData.type == 2">
            <div class="input_block">
              <div><img src="../../../assets/img/userIcon.png" /></div>
              <input
                type="text"
                placeholder="请输入账号"
                v-model="postData.mobile"
              />
            </div>
            <div class="input_block">
              <div><img src="../../../assets/img/pwdIcon.png" /></div>
              <input
                type="password"
                placeholder="请输入密码"
                v-model="postData.password"
              />
            </div>
          </section>
          <section v-if="postData.type == 1">
            <div class="input_block">
              <div><img src="../../../assets/img/phoneIcon.png" /></div>
              <input
                type="tel"
                maxlength="11"
                placeholder="请输入手机号"
                v-model="postData.mobile"
              />
            </div>
            <div class="input_block">
              <div>123</div>
              <input
                type="text"
                maxlength="6"
                placeholder="请输入验证码"
                v-model="postData.verifyCode"
              />
              <span class="c_p" @click="getVerify">{{ verifyBtn }}</span>
            </div>
          </section>
          <button class="loginButton" @click="login()">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let count = 60
let timer = null
export default {
  name: 'login',
  data () { // 所有的数据都写在里面
    return {
      postData: {
        mobile: '',
        password: '',
        verifyCode: '',
        type: 2
      },
      verifyBtn: '获取验证码'
    }
  },
  created () {

  },
  destroyed () {
  },
  mounted () {
  },
  methods: {
    changeTab (curr) {
      if (curr !== this.postData.type) {
        this.postData.type = curr
      }
    },
    login () {
      this.$axiox.post('/baigang/auth/login', this.postData).then(msg => {
        if (msg.code === 1) {
          return
        }
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '登录成功',
          stayTime: 5
        })
        window.localStorage.setItem('baigangToken', msg.data.token)
        window.localStorage.setItem('memberId', msg.data.memberId)
        this.$axiox.get('/baigang/sys/user/getCurrUserInfo').then(msg => {
          window.localStorage.setItem('MemberInfo', JSON.stringify(msg.data))
        })
        this.$router.push('index')
      })
    },
    getVerify () {
      this.verifyBtn = count + 's'
      if (timer === null) {
        this.$axiox.get('/baigang/auth/sendLoginVerifyCode/' + this.postData.mobile).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '验证码发送成功',
            stayTime: 5
          })
        })
        timer = setInterval(() => {
          count--
          this.verifyBtn = count + 's'
          if (count <= 0) {
            clearInterval(timer)
            this.verifyBtn = '获取验证码'
            count = 60
            timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>
#logn {
  overflow: auto;
}
.page_head {
  height: 70px;
  background-color: #ffffff;
  padding-left: 80px;
  font-size: 18px;
  font-weight: 500;
  line-height: 70px;
}
.page_body {
  height: calc(100% - 70px);
  background: url("../../../assets/img/backgroundImg.png") no-repeat center /
    cover;
  min-height: 500px;
}
.page_body .main_block {
  position: relative;
  width: 460px;
  height: 460px;
  top: 50%;
  left: 60%;
  transform: translateY(-230px);
  /*padding: 80px;*/
}
.main_block .bg_block {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(155deg, #fcfcfc 0%, #fcfcfc 0%, #f7f7f7 100%);
  opacity: 0.8;
  border-radius: 30px;
}
.main_block .content_block {
  position: absolute;
  top: 0;
  left: 0;
  padding: 72px 84px;
  width: calc(100% - 168px);
}
.tab_block {
  margin-bottom: 45px;
}
.tab_block li {
  display: inline;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  cursor: pointer;
  margin-right: 18px;
}
.tab_block li.selected {
  border-bottom: 3px solid #d71e1e;
}
.input_block {
  display: flex;
  width: 100%;
  margin-bottom: 36px;
  border-radius: 4px;
  overflow: hidden;
}
.input_block div {
  width: 42px;
  height: 42px;
  background: #303f59;
  text-align: center;
  line-height: 42px;
  font-weight: 400;
  color: #ffffff;
}
.input_block span {
  width: 74px;
  text-align: center;
  line-height: 42px;
  background-color: #fff;
  padding: 0 10px;
  font-weight: 400;
  white-space: nowrap;
  cursor: pointer;
  position: absolute;
  right: 84px;
  border-radius: 0px 4px 4px 0px;
}
.input_block div img {
  width: 24px;
  height: 24px;
}
.input_block input {
  flex: 1;
  border: none;
  padding: 5px 10px;
  outline: none;
}
.content_block button {
  margin-top: 84px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/login.vue